<div class=" pl-0 pt-3" style="margin-left: 2%;margin-right: 2%;">
  <div class="row  pt-2" style="display: flex;align-items: center;margin-bottom: 3%;">
    <div class="col-md-7 w-100">
      <p class="m-0 text-uppercase" style="font-size: 20px;color: #262756;font-weight: bold;">contacts</p>
      <small class="text-uppercase" style="font-size:15px;color: #959090;">Configuration des contacts </small>
    </div>
  </div>
  <div class="row rowposition  px-0">
    <div class="col-lg-12 col-xl-3 col-md-12 w-100 pl-0">
      <div>
      </div>
    </div>
    <div class="col-12 w-100 pl-0">
      <div class="row w-100 m-0 mb-2">
        <div class="col-4">
          <div class="export-icons d-flex mb-2">
            <div class="icn-sec">
              <img (click)="exportExcel(exportDirective, 'xlsx')" src="assets/newImages/excel-svg.svg"
                ngbTooltip="Expoter EXCEL" />
            </div>
            <div class="icn-sec">
              <img (click)="exportTable()" src="assets/newImages/pdf-svg.svg" ngbTooltip="Expoter PDF" />
            </div>
          </div>
        </div>
        <div class="col-4 w-100">
          <mat-form-field appearance="fill">
            <mat-label>Filtrer par nom du contact</mat-label>
            <input type="text" aria-label="Number" (keyup)="applyFilterer($event)" matInput [(ngModel)]="searchbyname"
              #input id="getdt" name="getdt" value="{{ searchbyname }}" />
            <button mat-button matSuffix mat-icon-button>
              <mat-icon placement="left" ngbTooltip="Actualiser les données des véhicules" (click)="resetContacts()">
                update</mat-icon>
            </button>
          </mat-form-field>
        </div>
        <div class="col-2  w-100" style="text-align: right;margin-top: -20px;">
          <img placement="left" ngbTooltip="Ajouter un contact" src="assets/icons/add-user.svg"
            (click)="add(addContact)" />
            <!-- <img placement="left" ngbTooltip="Supprimer conducteur"
            style="height: 86px;"
            src="assets/icons/icon-delete.svg"
            (click)="listItems.length ==1 && supprimerItem({id:0})"
            (click)="supprimerItem({id:0})"
             /> -->
             <!-- <img placement="left" *ngIf="listItems.length >1"
             style="height: 87px; "
             ngbTooltip="Supprimer conducteur" src="assets/icons/icon-delete.svg"
             (click)="supprimerItem({id:0})" /> -->


          </div>
          <div class="col-2 w-100">
            <div
            *ngIf="listItems.length >1"
              (click)="supprimerItem('moreThanOne',null,null)"
              class="mat-form-field"
              placement="left"
              ngbTooltip="Supprimer plusieurs plannification des rapports"
              style="
                height: 63px;
                display: flex;
                justify-content: center;
                align-items: center;
                width: 63px;
              "
            >
              <mat-icon style="font-size: 25px; padding: 0 !important"
                >delete_forever</mat-icon
              >
            </div>
          </div>
          <!-- (click)="listItems.length ==1 && supprimerItem({id:0})" -->
          <!-- [ngStyle]="{'cursor': listItems.length ==1 ? 'inherit':'auto'}" -->
      </div>
      <hr style="border: 1px solid #e8e4e4;margin-top: 3%;">
      <div class=" row rowposition pt-3 pl-0   w-100" style="margin-top: 2%;">
        <div class="col-12 col-md-12 w-100 mx-3" style="    padding: 0px; ">
          <div class="example-container-contact mat-elevation-z8 ">
            <ngx-spinner *ngIf="contactList ==true" bdColor="rgba(100,112,124,0.56)" size="medium" color="#233547"
              type="ball-clip-rotate-multiple" [fullScreen]="false">
              <p style="color: white"> </p>
            </ngx-spinner>
            <ngx-spinner *ngIf="contactListPost ==true" bdColor="rgba(100,112,124,0.56)" size="medium" color="#233547"
              type="ball-clip-rotate-multiple" [fullScreen]="false">
              <p style="color: white"> </p>
            </ngx-spinner>
            <table id="ExampleTable" class="table-hover" #exportDirective="matTableExporter" matTableExporter mat-table
              [dataSource]="dataSource" matSort>

              <ng-container matColumnDef="select">
                <th mat-header-cell *matHeaderCellDef>
                </th>
                <td mat-cell *matCellDef="let row">
                  <mat-checkbox disabled
                  (click)="$event.stopPropagation()"
                  (change)="$event ? selection.toggle(row) : null" [checked]="selection.isSelected(row)"
                  [aria-label]="checkboxLabel(row)">
                </mat-checkbox>
                </td>
              </ng-container>


              <ng-container matColumnDef="first_name">
                <th mat-header-cell mat-sort-header *matHeaderCellDef>
                  Prénom
                </th>
                <td mat-cell *matCellDef="let row"
                  [ngClass]="{ highlight: selectedRowIndex == row?.id  && selected == true}"
                >
                  {{ row?.first_name}}
                </td>
              </ng-container>
              <ng-container matColumnDef="last_name">
                <th mat-header-cell mat-sort-header *matHeaderCellDef>
                  Nom
                </th>
                <td mat-cell *matCellDef="let row"
                  [ngClass]="{highlight: selectedRowIndex == row?.id && selected == true}">
                  {{ row?.last_name}}
                </td>
              </ng-container>
              <ng-container matColumnDef="email">
                <th mat-header-cell mat-sort-header *matHeaderCellDef>
                  Email
                </th>
                <td mat-cell *matCellDef="let row"
                  [ngClass]="{ highlight: selectedRowIndex == row?.id && selected == true }"
                >
                  {{ row?.email }}
                </td>
              </ng-container>
              <ng-container matColumnDef="delete">
                <th mat-header-cell mat-sort-header *matHeaderCellDef>
                  Lié à un utilisateur
                </th>
                <td mat-cell *matCellDef="let row"
                  [ngClass]="{ highlight: selectedRowIndex == row?.id && selected == true}"
                >
                  Utilisateur
                </td>
              </ng-container>
              <ng-container matColumnDef="action">
                <th mat-header-cell mat-sort-header *matHeaderCellDef>
                  Actions
                </th>
                <td mat-cell *matCellDef="let row"
                  [ngClass]="{ highlight: selectedRowIndex == row?.id && selected == true}">
                  <a [ngStyle]="{'pointer-events': listItems.length >1 ? 'none' : 'all'
                    , 'opacity':listItems.length >1 ?'0.5' : '1'}">
                    <img placement="left" ngbTooltip="Détails du contact" src="assets/icons/icon-details.svg"
                         (click)="afficher_details(row)" />
                  </a>
                  <a
                    [ngStyle]="{'pointer-events': listItems.length >1 ? 'none' : 'all'
                    , 'opacity':listItems.length >1 ?'0.5' : '1'}">
                    <img placement="left" ngbTooltip="Modifier" src="assets/icons/icon-modifier.svg"
                         (click)="modifierItem(row,editContact)" />
                  </a>
                     <a
                     [ngStyle]="{'pointer-events': listItems.length >1 ? 'none' : 'all'
                    , 'opacity':listItems.length >1 ?'0.5' : '1'}"
                     >

                      <img placement="left"
                      ngbTooltip="Supprimer véhicule"
                      src="assets/icons/icon-delete.svg"
                      (click)=" supprimerItem('oneItem',row.id)"/></a>

                </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row (click)="goToBottom(820)" *matRowDef="let row; columns: displayedColumns;"
              (click)="selection.toggle(row)"></tr>
              <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" colspan="4">
                  Aucune donnée correspondante à votre recherche
                </td>
              </tr>
            </table>
          </div>
          <mat-paginator #paginator [pageSize]="pageSize" (page)="pageChanged($event)"
            [pageSizeOptions]="pageSizeOptions" showFirstLastButtons [length]="lengthTotal">
          </mat-paginator>
        </div>
      </div>
    </div>
  </div>
</div>
<ng-template #addContact let-c="close">
  <button class="close" id ="cancel-add"  matDialogClose>X</button>
  <h2 style="text-align: center; padding-top: 20px;    letter-spacing: 1.43px;
                  color: #262756; font-weight: bold;" class="text-uppercase">un nouveau contact </h2>
  <form class="mt-4" [formGroup]="registerFormContact" (submit)="submitForm()">
    <div class="col-md-12 pt-2" style=" margin-bottom: 20px;">
      <mat-form-field class="example-full-width appearance-fill" appearance="fill" style="width: 100%;">
        <mat-label>Nom</mat-label>
        <input matInput formControlName="last_name" required>
        <mat-error *ngIf="registerFormContact.get('last_name').hasError('pattern')">Veuillez saisir une format
          valide !
        </mat-error>
        <mat-error *ngIf="registerFormContact.get('last_name').hasError('required')">
          Nom est <strong>Obligatoire</strong>
        </mat-error>
      </mat-form-field>
    </div>
    <div class="col-md-12" style=" margin-bottom: 20px;">
      <mat-form-field class="example-full-width appearance-fill" appearance="fill" style="width: 100%;">
        <mat-label>Prénom</mat-label>
        <input matInput formControlName="first_name" required>
        <mat-error *ngIf="registerFormContact.get('first_name').hasError('pattern')">Veuillez saisir une format
          valide !
        </mat-error>
        <mat-error *ngIf="registerFormContact.get('first_name').hasError('required')">
          Prénom est <strong>Obligatoire</strong>
        </mat-error>
      </mat-form-field>
    </div>
    <div class="col-md-12" style=" margin-bottom: 20px;">
      <mat-form-field class="example-full-width appearance-fill" appearance="fill" style="width: 100%;">
        <mat-label>Courrier électronique</mat-label>
        <input matInput type="email" autocomplete="off" formControlName="email" [errorStateMatcher]="matcher" required>
        <mat-error *ngIf="registerFormContact.get('email').hasError('email')">Veuillez saisir une format valide !
        </mat-error>
        <mat-error *ngIf="registerFormContact.get('email').hasError('required')">
          Email est <strong>Obligatoire</strong>
        </mat-error>
      </mat-form-field>
    </div>
    <div class="col-md-12 pb-2" style=" margin-bottom: 20px;">
      <mat-form-field class="example-full-width appearance-fill" appearance="fill" style="width: 100%;">
        <mat-label>Numéro de téléphone</mat-label>
        <input type="number" matInput formControlName="gsm_number">
      </mat-form-field>
    </div>
  </form>
  <div class=" justify-content-center d-flex pb-3">
    <div class="example-button-container px-2">
      <button mat-button type="submit" class="btn-get justify-content-center" [cValue] = "this.c"(click)="submitForm()">
        Ajouter
      </button>
    </div>
  </div>
</ng-template>
<ng-template #editContact>
  <button id ="cancel-edit" class="close" matDialogClose>X</button>
  <h2 style="text-align: center; padding-top: 20px;    letter-spacing: 3px;
                  color: #262756;" class="text-uppercase">Modifier contact </h2>
  <form class="mt-4" [formGroup]="registerFormContactupdate" (submit)="submitUpdateForm()">
    <div class="col-md-12 pt-2" style=" margin-bottom: 20px;">
      <mat-form-field class="example-full-width appearance-fill" appearance="fill" style="width: 100%;">
        <mat-label>Nom</mat-label>
        <input [(ngModel)]="last_name" matInput formControlName="last_name" required>
        <mat-error *ngIf="registerFormContactupdate.get('last_name').hasError('pattern')">Veuillez saisir une
          format valide !
        </mat-error>
        <mat-error *ngIf="registerFormContactupdate.get('last_name').hasError('required')">
          Nom est <strong>Obligatoire</strong>
        </mat-error>
      </mat-form-field>
    </div>
    <div class="col-md-12" style=" margin-bottom: 20px;">
      <mat-form-field class="example-full-width appearance-fill" appearance="fill" style="width: 100%;">
        <mat-label>Prénom</mat-label>
        <input [(ngModel)]="first_name" matInput formControlName="first_name" required>
        <mat-error *ngIf="registerFormContactupdate.get('first_name').hasError('pattern')">Veuillez saisir une
          format valide !
        </mat-error>
        <mat-error *ngIf="registerFormContactupdate.get('first_name').hasError('required')">
          Prénom est <strong>Obligatoire</strong>
        </mat-error>
      </mat-form-field>
    </div>
    <div class="col-md-12" style=" margin-bottom: 20px;">
      <mat-form-field class="example-full-width appearance-fill" appearance="fill" style="width: 100%;">
        <mat-label>Courrier électronique</mat-label>
        <input matInput [(ngModel)]="email" type="email" formControlName="email" [errorStateMatcher]="matcher" required>
        <mat-error *ngIf="registerFormContactupdate.get('email').hasError('email')">Veuillez saisir une format
          valide !
        </mat-error>
        <mat-error *ngIf="registerFormContactupdate.get('email').hasError('required')">
          Email est <strong>Obligatoire</strong>
        </mat-error>
      </mat-form-field>
    </div>
    <div class="col-md-12 pb-2" style=" margin-bottom: 20px;">
      <mat-form-field class="example-full-width appearance-fill" appearance="fill" style="width: 100%;">
        <mat-label>Numéro de téléphone</mat-label>
        <input type="number" [(ngModel)]="gsm_number" matInput formControlName="gsm_number">
      </mat-form-field>
    </div>
  </form>
  <div class=" justify-content-center d-flex pb-3">
    <button (click)="submitUpdateForm()" mat-button type="submit" class="btn-get justify-content-center"
      (click)="submitForm()">
      Modifier
    </button>
  </div>
</ng-template>
